import { Badge, Card, Flex, Spinner, Tabs, Text } from '@radix-ui/themes';
import { debounce, isEmpty } from 'lodash';
import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Lists } from '../../../components/common/Lists';
import TableComponent from '../../../components/common/Tables';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';
import { useAppDispatch } from '../../../hooks/hooks';
import { useGetStudentDebtiesQuery, useGetStudentDebtsTotalByStudentIdQuery } from '../../../hooks/useGetStudentDebtiesQuery';
import { resetStudentData, setStudentData } from '../../../redux/slices/school/student';
import { resetUserData, setUserData } from '../../../redux/slices/users/user';
import { RootState } from '../../../redux/store';
import { routes } from '../../../routes';
import { getStudentByCode, getStudentById } from '../../../services/school/student/getStudentByCode';
import { getUserById } from '../../../services/user/getUsers';
import { UserPreview } from '../../Users/UserPreview';
import { useGetPaymentReferencesQuery } from '../../../hooks/useGetPaymentReferencesQuery';
import { Pencil1Icon, BellIcon, TrashIcon } from '@radix-ui/react-icons';
import { PaymentReferenceType, StudentDebtNotificationType, StudentDebtType } from '../../../types/Finance';
import toast from 'react-hot-toast';
import { setStudentDebtData } from '../../../redux/slices/finance/studentDebt';
import { getPaymentTransactions } from '../../../services/finance/paymentTransaction';
import { setPreviousPath } from '../../../redux/slices/previousPath';
import { getStudentDebt, updateStudentDebt } from '../../../services/finance/studentDebt';
import { Key_paymentreferences, Key_studentdebties, Key_studentTotals } from '../../../utils/constants';
import { ConfirmAlertDialog } from '../../../components/common/ConfirmAlertDialog';
import { createStudentDebtNotification } from '../../../services/finance/studentDebtNotification';
import { createPaymentReference, getReferenceCodeV2, updatePaymentReference } from '../../../services/finance/paymentReference';
import RadioGroupComponent from '../../../components/inputs/RadioGroup/RadioGroupComponent';
import { useGetSchoolBankConfigQuery } from '../../../hooks/useGetSchoolBankConfigQuery';
import { setPaymentsTransactionsData } from '../../../redux/slices/finance/paymentTransaction';
import { setPdfPreviewType } from '../../../redux/slices/report/report';
type ActiveSegmentTab = 'totalStudentDebts' | 'studentDebts' | 'paymentReferences' | 'payed';
const columnNamesMapStudentDebt: { [key: string]: string } = {
  paymentType: "Tipo de pagamento",
  originalAmount: "Valor a pagar",
  currentAmount: "Valor remanescente",
  dueDate: "Ate data a pagar",
  description: "Descrição",
  isPayedIcon: "Pago ?",
};
const columnNamesMapPaymentReference: { [key: string]: string } = {
  paymentType: "Tipo de pagamento",
  referenceCode: "Ref.",
  entity: "Entidade",
  amount: "Valor",
  // dueDate: "Ate data a pagar",
  isPayedIcon: "Pago ?",
};
export const CheckStudentDebtByStudent = () => {
  const [activeSegment, setActiveSegment] = useState<ActiveSegmentTab>('totalStudentDebts');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const [generateRefItem, setGenerateRefItem] = useState<StudentDebtType | null>(null);

  const [currentPageStudentDebt, setCurrentPageStudentDebt] = useState(1);
  const [currentPagePaymentReferences, setCurrentPagePaymentReferences] = useState(1);
  const [deleteItem, setDeleteItem] = useState<StudentDebtType | null>(null);
  const [deletePaymentReference, setDeletePaymentReference] = useState<PaymentReferenceType | null>(null);
  const mutationSaveStudentDebtNotification = useMutation({ mutationFn: createStudentDebtNotification, mutationKey: 'createStudentDebtNotification' });
  const mutationUpdatePaymentReference = useMutation({ mutationFn: updatePaymentReference, mutationKey: 'updatePaymentReference' });
  const { data: schoolBankConfigsData, status: schoolBankConfigsStatus } = useGetSchoolBankConfigQuery({ PageNumber: 1, PageSize: 400 });

  const userData = useSelector((state: RootState) => state.user);
  const studentData = useSelector((state: RootState) => state.student);
  const { data: studentDebtsData, refetch: fetchStudentDebts, status: studentDebtsStatus } = useGetStudentDebtiesQuery({ PageNumber: 1, PageSize: 4000, IdStudent: studentData?.student?.id },
    {
      enabled: !!studentData?.student?.id
    }
  )
  const { data: studentDebtsTotalsData } = useGetStudentDebtsTotalByStudentIdQuery(studentData?.student?.id,
    {
      enabled: !!studentData?.student?.id
    }
  )
  const { data: paymentReferencesData, refetch: fetchPaymentReferences, status: paymentReferencesStatus } = useGetPaymentReferencesQuery({ PageNumber: 1, PageSize: 4000, IdStudent: studentData?.student?.id },
    {
      enabled: !!studentData?.student?.id
    }
  )
  const { control, formState: { errors }, setValue, getValues } = useForm<
    {
      studentCode: string,
      bankEntity?: string;
      deletedReason?: string;
      deletedReasonOther?: string;
    }>
    (
      {
        // resolver: yupResolver(CreateStudentDebtFormValidation),
        defaultValues: { studentCode: "" },
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );
  const handleBack = () => {
    navigate(routes.studentDebts);
    dispatch(resetStudentData());
    dispatch(resetUserData());
  }
  const { isLoading: isLoadingGetStudent, refetch: fetchStudentByCode, isError: isErrorGetStudent, error } = useQuery(
    ['getStudentByCode'],
    async () => {
      try {
        const studentData = await getStudentByCode(getValues('studentCode'));
        if (!studentData) return;
        const userData = await getUserById(studentData.idUser)
        if (!userData) return;
        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));

      } catch (error) {
        dispatch(resetStudentData());
        dispatch(resetUserData());
      }
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false
    }
  );
  const handleStudentCodeChange = useCallback(
    debounce((value: string) => {
      const trimmedValue = value.trim();
      setValue('studentCode', trimmedValue);
      if (isEmpty(trimmedValue)) {
        dispatch(resetStudentData());
        dispatch(resetUserData());
        return;
      }
      if (trimmedValue.length >= 3) {
        fetchStudentByCode();
        fetchStudentDebts();
        fetchPaymentReferences();
      } else {
        dispatch(resetStudentData());
        dispatch(resetUserData());
      }
    }, 300),
    [setValue, fetchStudentByCode, fetchStudentDebts]
  );
  const navigateAndValidate = (tabToNavigateTo: ActiveSegmentTab) => {
    if (activeSegment !== tabToNavigateTo) setActiveSegment(tabToNavigateTo);
    //trigger();
  }
  const studentDebtsNotPayed = studentDebtsData?.items.filter(sd => !sd.isPayed && sd.idStudent === studentData.student?.id);
  const studentDebtsPayed = studentDebtsData?.items.filter(sd => sd.isPayed && sd.idStudent === studentData.student?.id);

  const studentPaymentReferences = paymentReferencesData?.items.filter(sd => sd.idStudent === studentData.student?.id);
  const totalDebts = studentDebtsTotalsData?.totalDebt;
  const handlePageChangeStudentDebt = (page: number) => {
    setCurrentPageStudentDebt(page);
  };
  const handlePageChangePaymentReference = (page: number) => {
    setCurrentPagePaymentReferences(page);
  };
  const handleEdit = (c: StudentDebtType) => {
    c.isPayedIcon = '';

    if (c.currentAmount != c.originalAmount || c.isPayed) {
      toast.error("Não pode editar Cobrança")
      return;
    }
    dispatch(setStudentDebtData(c));
    dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
    navigate(routes.updateStudentDebt)

  };
  const handlePayStudentDebt = async (c: StudentDebtType) => {
    if (c.isPayed) {
      toast.success("Cobrança paga");
      return;
    }
    try {
      let { items } = await getPaymentTransactions({ PageSize: 4000, PageNumber: 1, IdStudentDebt: c.id })
      items = items.filter(i => i.idStudentDebt === c.id);
      c.isPayedIcon = '';
      c.paymentTransation = items;
      dispatch(setStudentDebtData(c));
      dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
      navigate(routes.payStudentDebt)
    } catch {
      toast.error("Ops! Ocorreu um erro");
    }
  };
  const handleNotifyStudentDebt = async (c: StudentDebtType) => {
    c.isPayedIcon = '';
    if (c.isPayed) {
      toast.error("Cobrança paga, não será possivel notificar estudante");
      return;
    }
    dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
    dispatch(setStudentDebtData(c));
    try {
      const data: StudentDebtNotificationType = {
        idStudentDebt: c.id!,
        isViewed: false,
        message: `${c.paymentType},  ${c.description ?? ""} No valor de ${c?.currentAmount?.toFixed(1)}Mtn`,
        status: true
      };
      await mutationSaveStudentDebtNotification.mutateAsync(data);
      toast.success("Estudante notificado");
    } catch (error) {
      toast.error("Ops, ocorreu um erro!");
    }
  };
  const handleCheckPayments = async (c: StudentDebtType) => {
    c.isPayedIcon = '';
    try {
      let { items } = await getPaymentTransactions({ PageSize: 4000, PageNumber: 1, IdStudentDebt: c.id })
      items = items.filter(i => i.idStudentDebt === c.id);
      c.isPayedIcon = '';
      c.paymentTransation = items;
      dispatch(setStudentDebtData(c));
      dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
      navigate(routes.checkPayments)
    } catch {
      toast.error("Ops! Ocorreu um erro");
    }
  };

  const mutationUpdate = useMutation(updateStudentDebt, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_studentdebties);
      queryClient.invalidateQueries(Key_paymentreferences);
      queryClient.invalidateQueries(Key_studentTotals);
      toast.success('Cobrança apagada');
    },
    onError: () => {
      toast.error("Erro ao apagar Cobrança")
    }
  });
  const openDeleteDialog = (c: StudentDebtType) => {
    if (c.isPayed) {
      toast.error("Cobrança paga, não será possivel apagar");
      return;
    }
    if (c.currentAmount != c.originalAmount) {
      toast.error("Cobrança em pagamento, não será possivel apagar");
      return;
    }
    setDeleteItem(c);
  };
  const openDeletePaymentReferenceDialog = (c: PaymentReferenceType) => {
    if (c.isPayed) {
      toast.error("Ref. paga, não será possivel apagar");
      return;
    }
    setDeletePaymentReference(c);
  };
  const handleDeletePaymentReference = async (c: PaymentReferenceType) => {
    try {
      c.status = false;
      c.paymentDate = null;
      await mutationUpdatePaymentReference.mutateAsync(c)
      queryClient.invalidateQueries(Key_paymentreferences);
      toast.success('Ref. apagada');

    } catch (ex) {
      toast.error("Erro ao apagar")
    }
  };
  const handleDelete = (c: StudentDebtType) => {
    c.status = false;
    c.isPayedIcon = '';
    mutationUpdate.mutateAsync(c)
  };
  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem!)
    }
  };
  const confirmDeletePaymentReference = async () => {
    if (deletePaymentReference) {
      await handleDeletePaymentReference(deletePaymentReference!)
    }
  };

  const openGenerateRefDialog = (c: StudentDebtType) => {
    if (c.isPayed) {
      toast.error("Cobrança paga, não será possivel gerar referencia");
      return;
    }
    setGenerateRefItem(c);
  };

  const handlePrintInvoice = async (c: StudentDebtType) => {
    try {
      // if(c.isPayed){
      //   toast.error("Não é possivel obter cobrança paga no momento");
      //   return;
      // }
      const studentDebtDataRequest = await getStudentDebt({ PageSize: 1, PageNumber: 1, Id: c.id });
      const paymentReferences = studentDebtDataRequest?.items
        .flatMap((sdr) => sdr.paymentReferences || [])
        .filter((ref) => ref?.id)
        // .filter((ref) => !ref?.isPayed)
        .filter((ref) => ref.status);
      let studentDebt = studentDebtDataRequest?.items?.at(0)!;
      const paymentReference = paymentReferences?.find(p => p.amount === studentDebt.originalAmount);
      if (paymentReference) {
        studentDebt.entityCode = paymentReference.entity;
        studentDebt.referenceCode = paymentReference.referenceCode;
        studentDebt.bankDescription = schoolBankConfigsData?.items.find(i => i.bankEntity == paymentReference.entity)?.bankDescription ?? schoolBankConfigsData?.items.find(i => i.bankEntity == paymentReference.entity)?.bankName ?? "";
        studentDebt.bankName = schoolBankConfigsData?.items.find(i => i.bankEntity == paymentReference.entity)?.bankName ?? "";
      }
      try {
        const studentData = await getStudentById(studentDebt.idStudent);
        const userData = await getUserById(studentData.idUser)
        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));
      } catch (error) {
        console.error(error)
      }
      dispatch(setStudentDebtData(studentDebt))
      dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
      dispatch(setPdfPreviewType('INVOICE'))
      navigate(routes.pdfPreview)
    } catch (error) {
      console.error(error)
    }
  }
  const mutationSaveReferenceCode = useMutation({ mutationFn: createPaymentReference, mutationKey: 'createPaymentReference' });

  const handlePrintReceipt = async (c: StudentDebtType) => {
    if (!c.isPayed) {
      toast.error("Ainda não foi pago");
      return;
    }
    try {
      const studentDebtDataRequest = await getStudentDebt({ PageSize: 1, PageNumber: 1, Id: c.id });
      const paymentsTransactions = studentDebtDataRequest?.items
        .flatMap((sdr) => sdr.paymentTransactions || [])
        .filter((ref) => ref?.id)
        .filter((ref) => ref.status);
      const studentDebt = studentDebtDataRequest?.items.at(0)!
      try {
        const studentData = await getStudentById(studentDebt.idStudent);
        const userData = await getUserById(studentData.idUser)
        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));
      } catch (error) {
        console.error(error)
      }
      dispatch(setPaymentsTransactionsData(paymentsTransactions))
      dispatch(setStudentDebtData(studentDebt))
      dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
      dispatch(setPdfPreviewType('RECEIPT'))
      navigate(routes.pdfPreview)
    } catch (error) {
      console.error(error)
    }
  }
  const confirmGenerateRef = async () => {
    if (generateRefItem) {
      await handleGenerateReference(generateRefItem!)
    }
  };

  const handleGenerateReference = async (c: StudentDebtType) => {
    if (c.isPayed) {
      toast.error("Pago, não será possivel gerar referencia");
      return;
    }
    try {
      const bankEntity = getValues('bankEntity');
      if (isEmpty(bankEntity)) {
        toast.error("Selecione uma entidade bancaria");
        return;
      }
      const currentDate = new Date();
      let referenceCode = '';
      const getReferenceCodeRequest = {
        amount: c.currentAmount,
        idStudent: c.idStudent,
        idPaymentType: c.idPaymentType,
        idStudentDebt: c.id,
        month: (currentDate.getMonth() + 1).toString(),
        year: currentDate.getFullYear().toString(),
        description: c.description,
        idBankEntity: bankEntity,
        entity: String(schoolBankConfigsData?.items.find(i => i.id === getValues('bankEntity'))?.bankEntity)
      }
      try {
        referenceCode = await getReferenceCodeV2(getReferenceCodeRequest);
      } catch (ex: any) {
        toast.error(ex?.message);
        return;
      }
      if (isEmpty(referenceCode)) {
        toast.error("Ops, não foi possivel gerar referencia");
        return;
      }
      const data: PaymentReferenceType = {
        idStudent: c.idStudent,
        idPaymentType: c.idPaymentType,
        amount: c.currentAmount,
        dueDate: new Date(c.dueDate).toISOString(),
        referenceCode: referenceCode,
        idStudentDebt: c.id,
        entity: String(schoolBankConfigsData?.items.find(i => i.id === getValues('bankEntity'))?.bankEntity),
        idBankEntity: bankEntity
      }
      await mutationSaveReferenceCode.mutateAsync(data)
      toast.success("Referencia gerada");
     // reset();
      c.referenceCode = referenceCode;
      c.entityCode = getReferenceCodeRequest.entity;
      try {
        const studentData = await getStudentById(c.idStudent);
        const userData = await getUserById(studentData.idUser)
        dispatch(setStudentData(studentData));
        dispatch(setUserData(userData));
      } catch (error) {
        dispatch(resetStudentData());
        dispatch(resetUserData());
      }
      dispatch(setStudentDebtData({ ...c }))
      dispatch(setPdfPreviewType('INVOICE'))
      navigate(routes.pdfPreview);
    } catch (ex) {
      toast.error("Ops, ocorreu um erro!");
    }
  };

  const optionsStudentDebts = studentDebtsNotPayed?.map((c: StudentDebtType) => [
    {
      label: 'Editar',
      onClick: () => handleEdit(c),
      icon: <Pencil1Icon />
    },
    {
      label: 'Pagar',
      onClick: () => handlePayStudentDebt(c),
      icon: <Pencil1Icon />
    },
    {
      label: 'Transações de pagamento',
      onClick: () => handleCheckPayments(c),
      icon: <Pencil1Icon />
    },
    {
      label: 'Notificar Cobrança',
      onClick: () => handleNotifyStudentDebt(c),
      icon: <BellIcon />
    },
    {
      label: 'Gerar referência de pagamento',
      onClick: (c: StudentDebtType) => openGenerateRefDialog(c),
      icon: <BellIcon />
    },
    {
      label: 'Imprimir cobrança',
      onClick: (c: StudentDebtType) => handlePrintInvoice(c),
      icon: <BellIcon />
    },
    {
      label: 'Imprimir recibo',
      onClick: (c: StudentDebtType) => handlePrintReceipt(c),
      icon: <BellIcon />
    },
    {
      label: 'Excluir',
      onClick: () => openDeleteDialog(c),
      icon: <TrashIcon />
    }
  ]) || [];

  const optionsStudentDebtsPayed = studentDebtsPayed?.map((c: StudentDebtType) => [
    {
      label: 'Transações de pagamento',
      onClick: () => handleCheckPayments(c),
      icon: <Pencil1Icon />
    },
    {
      label: 'Imprimir cobrança',
      onClick: (c: StudentDebtType) => handlePrintInvoice(c),
      icon: <BellIcon />
    },
    {
      label: 'Imprimir recibo',
      onClick: (c: StudentDebtType) => handlePrintReceipt(c),
      icon: <BellIcon />
    },
  ]) || [];

  const optionsStudentReferences = studentPaymentReferences?.map((c: PaymentReferenceType) => [
    {
      label: 'Excluir',
      onClick: () => openDeletePaymentReferenceDialog(c),
      icon: <TrashIcon />
    }
  ]) || [];

  return (
    <>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent
            name="studentCode"
            label="Código do estudante"
            control={control}
            errors={errors}
            fieldProps={{
              placeholder: 'Digite o código do estudante',
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleStudentCodeChange(e.target.value),
              onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
                e.preventDefault();
                const pastedText = e.clipboardData.getData('text');
                handleStudentCodeChange(pastedText);
              }
            }}
            required={true}
          />
          {isLoadingGetStudent ? <Spinner loading></Spinner>
            : <UserPreview />
          }
          <Tabs.Root value={activeSegment}
            onValueChange={(tabToNavigate) => {
              navigateAndValidate(tabToNavigate as ActiveSegmentTab);
            }}
          >
            <Tabs.List>
              <Tabs.Trigger value="totalStudentDebts">Total em dividas</Tabs.Trigger>
              <Tabs.Trigger value="payed">Pagamentos</Tabs.Trigger>
              <Tabs.Trigger value="studentDebts">Cobranças</Tabs.Trigger>
              <Tabs.Trigger value="paymentReferences">Referências</Tabs.Trigger>
            </Tabs.List>
            <Tabs.Content value="totalStudentDebts">
              <Flex style={{ padding: '2%' }}>
                Cobranças:  <Text color='red' style={{ marginLeft: '4px' }}>
                  {
                    totalDebts?.toFixed(2)
                  }Mtn
                </Text>
              </Flex>
            </Tabs.Content>
            <Tabs.Content value="payed">
              <>
                <Lists
                  status={studentDebtsStatus}
                  TableComponent={() =>
                    <TableComponent
                      columns={Object.keys(columnNamesMapStudentDebt)}
                      items={studentDebtsPayed?.map(item => {
                        return {
                          ...item,
                          isPayedIcon: item.isPayed ? <><Badge color="green">
                            Pago
                          </Badge> </> :
                            <Badge color="red">
                              Não pago
                            </Badge>
                        }
                      })}
                      options={optionsStudentDebtsPayed}
                      columnNamesMap={columnNamesMapStudentDebt}
                      totalPages={studentDebtsPayed?.length || 1}
                      currentPage={currentPageStudentDebt}
                      onPageChange={handlePageChangeStudentDebt}
                    />
                  }
                  handleClickCreate={undefined}
                />
              </>
            </Tabs.Content>
            <Tabs.Content value="studentDebts">
              <>
                <Lists
                  status={studentDebtsStatus}
                  TableComponent={() =>
                    <TableComponent
                      columns={Object.keys(columnNamesMapStudentDebt)}
                      items={studentDebtsNotPayed?.map(item => {
                        return {
                          ...item,
                          isPayedIcon: item.isPayed ? <><Badge color="green">
                            Pago
                          </Badge> </> :
                            <Badge color="red">
                              Não pago
                            </Badge>
                        }
                      })}
                      options={optionsStudentDebts}
                      columnNamesMap={columnNamesMapStudentDebt}
                      totalPages={studentDebtsNotPayed?.length || 1}
                      currentPage={currentPageStudentDebt}
                      onPageChange={handlePageChangeStudentDebt}
                    />
                  }
                  handleClickCreate={undefined}
                />
                <ConfirmAlertDialog
                  open={!!deleteItem}
                  onOpenChange={(open) => !open && setDeleteItem(null)}
                  title="Esta operação é irreversível"
                  item={deleteItem}
                  onConfirm={confirmDelete}
                  onCancel={() => setDeleteItem(null)}
                />
              </>
            </Tabs.Content>
            <Tabs.Content value="paymentReferences">
              <>
                <Lists
                  status={paymentReferencesStatus}
                  TableComponent={() =>
                    <TableComponent
                      columns={Object.keys(columnNamesMapPaymentReference)}
                      items={studentPaymentReferences?.map(item => {
                        return {
                          ...item,
                          isPayedIcon: item.isPayed ? <><Badge color="green">
                            Pago
                          </Badge> </> :
                            <Badge color="red">
                              Não pago
                            </Badge>
                        }
                      })}
                      options={optionsStudentReferences}
                      columnNamesMap={columnNamesMapPaymentReference}
                      totalPages={studentPaymentReferences?.length || 1}
                      currentPage={currentPagePaymentReferences}
                      onPageChange={handlePageChangePaymentReference}
                    />
                  }
                  handleClickCreate={undefined}
                />
                <ConfirmAlertDialog
                  open={!!deletePaymentReference}
                  onOpenChange={(open) => !open && setDeletePaymentReference(null)}
                  title="Esta operação é irreversível"
                  item={deletePaymentReference}
                  onConfirm={confirmDeletePaymentReference}
                  onCancel={() => setDeletePaymentReference(null)}
                />
              </>
            </Tabs.Content>
          </Tabs.Root>
        </Flex>
      </Card>
      <ConfirmAlertDialog
        open={!!generateRefItem}
        descriptionComponent={
          <>
            <RadioGroupComponent name="bankEntity" control={control} errors={errors} label="Entidade" style={{ width: '100%' }}
              options={schoolBankConfigsData?.items.map(i => {
                return {
                  value: String(i.id!),
                  label: String(i.bankEntity!)
                }
              }) ?? []
              }
              fieldProps={{
                style: { display: 'flex', flexDirection: 'row', gap: '16px' }
              }}
              required={true}
            />
          </>
        }

        onOpenChange={(open) => !open && setGenerateRefItem(null)}
        title="Esta operação é irreversível"
        item={generateRefItem}
        onConfirm={confirmGenerateRef}
        onCancel={() => setGenerateRefItem(null)}
      />
    </>
  )
}
